import React from 'react';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import useDeviationGroupListPopup from '../../../../DeviationGroupListPopup/useDeviationGroupListPopup';
import { ResourceType } from '../../../../types/resource';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import GroupCard from '../../../../GroupCard';
import s from './Groups.scss';
const Groups = ({ block, deviation: parentDeviation })=>{
    var _block_groups_map, _this;
    const onSeeAllClick = useDeviationGroupListPopup(parentDeviation);
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block,
        onSeeAllClick: onSeeAllClick
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['grid']
    }, (_this = block.groups) === null || _this === void 0 ? void 0 : (_block_groups_map = _this.map) === null || _block_groups_map === void 0 ? void 0 : _block_groups_map.call(_this, (group, index)=>/*#__PURE__*/ React.createElement(GroupCard, {
            key: group.userId,
            username: group.username,
            imageUrl: group.usericon,
            className: s['grid-item'],
            biData: BiData({
                evid: 101,
                typeid: ResourceType.GROUP,
                itemid: group.userId,
                sectionname: BiContextProvidedValue,
                _rankIndex: index
            })
        }))));
};
Groups.displayName = 'Groups';
export default Groups;
